// Support component names relative to this directory:
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import axios from 'axios';

const componentRequireContext = require.context('components', true);
const ReactRailsUJS = require('react_ujs');

ReactRailsUJS.useContext(componentRequireContext);

let csrfTokenPromise = null;

const fetchCSRFToken = async () => {
  try {
    const {data} = await axios.get('/products/csrf');
    return data.csrf_token;
  } catch (error) {
    console.error('Failed to fetch CSRF token', error);
    return null;
  }
};

const getCSRFToken = () => {
  if (!csrfTokenPromise) {
    csrfTokenPromise = fetchCSRFToken();
  }
  return csrfTokenPromise;
};

axios.interceptors.request.use(
  async (config) => {
    if (config.url === '/products/csrf') {
      return config;
    }

    const methodsNeedingCSRF = ['post', 'put', 'patch', 'delete'];
    if (methodsNeedingCSRF.includes(config.method?.toLowerCase())) {
      const csrfToken = await getCSRFToken();

      if (csrfToken) {
        config.headers = config.headers || {};
        config.headers['X-CSRF-Token'] = csrfToken;
      }
    }

    config.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...config.headers
    };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
